import { Modal, Text } from '@atoms/index';
import Image from "@atoms/Image";
import React from "react";
import texts from "@molecules/Footer/V2/en.json";
import { QRCodeCanvas } from 'qrcode.react';
import useQrValue from '@hooks/useQrValue';
import { getCookie } from '@helpers/url-utm-handler';
import { appQrCode } from '@helpers/constants';

const DownloadAppQrCode = ({
    show,
    onClose,
    qrCode = null
}) => {
    const qrValue = useQrValue();
    const visitUrlCookie = getCookie('visit_url');

    return (
        <Modal
            show={show}
            onClose={onClose}
            roundedClass={'rounded-3xl'}
            width="hidden md:block md:w-[543px]"
            className="!px-0 !pt-0 !pb-0"
            hideTitle={true}
            children={
                <>
                    <div className="relative px-4 py-4">
                        <div className="flex flex-col items-center w-full px-4 py-1">
                            {visitUrlCookie && !qrCode
                                ? 
                                <>
                                    <QRCodeCanvas fgColor='rgb(38 36 123)' value={qrValue} size={160} level="H" />
                                    <div className="absolute top-1/2 left-1/2 w-[50px] h-[50px] -translate-x-1/2 -translate-y-1/3 bg-white p-1 shadow flex justify-center items-center rounded-md">
                                        <Image
                                            src="/images/altGraaf-favicon.svg"
                                            alt="Logo"
                                            width={40}
                                            height={40}
                                            className="object-contain"
                                        />
                                    </div>
                                </>
                                : <Image
                                    src={qrCode || appQrCode}
                                    alt="qr-code"
                                    width="190"
                                    height="190"
                                />
                            }
                            <Text
                                className={`p4-medium text-gray-500 mt-3`}
                                content={texts?.ScanTheQrCode}
                            />
                        </div>
                        <div
                            className={"absolute right-4 top-4"}
                            onClick={onClose}
                        >
                            <Image
                                src={'/images/footer/close.svg'}
                                alt="close"
                                className={"w-6 h-6"} />
                        </div>
                    </div>
                </>
            }
        />
    );
};

export default DownloadAppQrCode;
